import { render, staticRenderFns } from "./CoozzyBriefButlerIcon.vue?vue&type=template&id=84325d50&scoped=true"
import script from "./CoozzyBriefButlerIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyBriefButlerIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyBriefButlerIcon.vue?vue&type=style&index=0&id=84325d50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84325d50",
  null
  
)

export default component.exports